// PERMISSIONS
export const PERMISSIONS_FETCH_DATA_SUCCESS = 'PERMISSIONS_FETCH_DATA_SUCCESS';
export const PERMISSIONS_FETCH_DATA_ERROR = 'PERMISSIONS_FETCH_DATA_ERROR';
